import React from "react";

const badgeBase = {
  display: "inline-block",
  marginLeft: 6,
  padding: "1px 7px",
  borderRadius: 10,
  fontSize: 11,
  fontWeight: 600,
  lineHeight: "16px",
  verticalAlign: "middle",
  whiteSpace: "nowrap",
};

const weekendStyle = {
  ...badgeBase,
  background: "#fff3e0",
  color: "#e65100",
  border: "1px solid #ffb74d",
};

const lowSeasonStyle = {
  ...badgeBase,
  background: "#e0f7f4",
  color: "#00695c",
  border: "1px solid #4db6ac",
};

/**
 * Badges weekend / temporada baja junto a duración u otras filas admin.
 * Acepta snapshot de buildRentalPromoSnapshot o flags sueltos.
 */
export const RentalPromoBadges = ({
  promo,
  isWeekend,
  lowSeasonPct,
  style,
}) => {
  const weekend =
    promo != null ? !!promo.is_weekend : !!isWeekend;
  const pct =
    promo != null
      ? Number(promo.low_season_pct) || 0
      : Number(lowSeasonPct) || 0;

  if (!weekend && pct <= 0) return null;

  return (
    <span style={style}>
      {weekend && <span style={weekendStyle}>weekend</span>}
      {pct > 0 && (
        <span style={lowSeasonStyle}>{`low season -${pct}%`}</span>
      )}
    </span>
  );
};

export default RentalPromoBadges;



// WEBPACK FOOTER //
// ./src/components/RentalPromoBadges.js